import React from 'react';
import { compose, withProps, setDisplayName } from 'recompose';
import * as R from 'ramda';
import { showHubSwitcher } from '../../common/utils';
import HubSwitcher from '../hub-switcher';
import { SignOut } from '../more-menu';
import Links from '../more-menu/links';
import { withNamespaces } from 'react-i18next';

const popoverMenuItems = (t, enabledFeatures, onProfileModalOpen) => [
  { type: 'contact_admin', path: '/inbox/conversation/with_admin', label: t('Contact Admin'), title: t('Access Contact Admin page') },
  { type: 'feedback', path: '/feedbacks', label: t('Feedback'), title: t('Access Feedback page') },
  { type: 'terms_and_conditions', path: '/terms_and_conditions', label: t('Terms and Conditions'), title: t('Access Terms and Conditions page') },
  { type: 'language', path: '#', label: t('Language'), title: t('Language'), onClick: onProfileModalOpen }
].filter(R.cond([
  [itemType('feedback'), () => !enabledFeatures.includes('ux_debt')],
  [itemType('language'), () => enabledFeatures.includes('multilingual_content')],
  [R.T, R.T]
]));

const itemType = type => R.pipe(R.path(['type']), R.equals(type));

const Options = compose(
  withProps(({ t }) => ({
    signOutLink: [{
      type: 'sign_out',
      path: '/users/sign_out',
      label: t('Sign Out'),
      title: t('Sign Out')
    }]
  })),
  setDisplayName('ProfileOptions')
)(
  ({ features, hubSwitcher, t, unseenCounts, enabledFeatures, onProfileModalOpen, signOutLink }) => (
    <nav className="c-nav">
      <Links
        items={popoverMenuItems(t, enabledFeatures, onProfileModalOpen)}
        features={features}
        className="c-nav-list" />
      {showHubSwitcher(hubSwitcher) &&
        <HubSwitcher data={hubSwitcher} unseenCounts={unseenCounts} />}
      <SignOut items={signOutLink} className="c-sign-out" />
    </nav>
  )
);

export default withNamespaces()(Options);
